<template>
  <div style="padding:15px" class="containerTable">
    <vxe-toolbar
      id="toolbarId"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('fieldRequiredSetting_search_button')"
          @click="funcFilter"
          >查询</el-button
        >
        <el-button
          v-if="getLimit('fieldRequiredSetting_add_button')"
          @click="funcAdd"
          >新增</el-button
        >
        <el-button
          v-if="getLimit('fieldRequiredSetting_export_button')"
          @click="funcExport"
          >导出</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :footer-cell-class-name="footerCellClassName"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      :loading="loading"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="fieldName"
          title="字段名称"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.fieldName"
            placeholder="请输入字段名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="fieldValue"
          title="字段"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.fieldValue"
            placeholder="请输入字段"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isRequired"
          title="是否必填"
          :formatter="formatterIsRequired"
          min-width="120"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isRequired"
            placeholder="请选择"
            clearable
          >
            <el-option label="否" value="0" />
            <el-option label="是" value="1" />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="fieldFrom"
          title="功能模块"
          :formatter="formatterFieldFrom"
          min-width="120"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.fieldFrom"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in fieldFromOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('fieldRequiredSetting_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcDetail(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('fieldRequiredSetting_edit_button')"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text" @click="funcEdit(scope.row.code)">
              <i class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('fieldRequiredSetting_delete_button')"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <i class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelAddFlag"
      title="新增"
      width="700"
      height="400"
      resize
    >
      <compAdd
        ref="addRef"
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelEditFlag"
      title="编辑"
      width="700"
      height="400"
      resize
    >
      <compEdit
        ref="editRef"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelDetailFlag"
      title="详情"
      width="700"
      height="360"
      resize
    >
      <compDetail ref="detailRef" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compAdd from "./components/fieldRequiredSettingAdd.vue";
import compEdit from "./components/fieldRequiredSettingEdit.vue";
import compDetail from "./components/fieldRequiredSettingDetail.vue";
import request from "@/utils/request";
export default {
  name: "FieldRequiredSettingList",
  components: {
    compAdd,
    compEdit,
    compDetail
  },
  data() {
    return {
      message: "",
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modelEditFlag: false,
      modelDetailFlag: false,
      copy: false,
      exportObj: {
        exportUrl:
          "/ntocc-basic-api/fieldRequiredSetting/exportFieldRequiredSetting", //导出接口
        name: "必填设置"
      },
      listQuery: {
        fieldName: "",
        fieldValue: "",
        isRequired: "",
        fieldFrom: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      // 是否必填
      isRequiredOptions: [{ label: "否", value: 0 }, { label: "是", value: 1 }],
      fieldFromOptions: [
        { label: "实际承运人", value: "driver" },
        { label: "车队", value: "driverTeam" },
        { label: "托运人", value: "shipment" },
        { label: "企业托运人", value: "shipmentCompany" }
      ]
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      request({
        url: "/ntocc-basic-api/fieldRequiredSetting",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        this.loading = false;
      });
    },
    // 添加方法
    funcAdd() {
      this.$refs.addRef.$refs["form"].resetFields();
      this.modelAddFlag = true;
    },
    // 修改方法
    funcEdit(code) {
      this.$refs.editRef.getInfo(code);
      this.modelEditFlag = true;
    },
    // 详情方法
    funcDetail(code) {
      this.$refs.detailRef.getInfo(code);
      this.modelDetailFlag = true;
    },
    // 删除方法
    funcDelete(row) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          request({
            url: `/ntocc-basic-api/fieldRequiredSetting`,
            method: "delete",
            params: { codes: row }
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "edit":
          this.modelEditFlag = false;
          break;
        case "detail":
          this.modelDetailFlag = false;
          break;
        default:
      }
    },
    // 底部颜色设置
    footerCellClassName({ $rowIndex, column, columnIndex }) {
      if (columnIndex === 0) {
        if ($rowIndex === 0) {
          return "col-blue";
        } else {
          return "col-red";
        }
      }
    },
    // 设置底部合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    },
    formatterIsRequired({ cellValue }) {
      const item = this.isRequiredOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterFieldFrom({ cellValue }) {
      const item = this.fieldFromOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    }
  }
};
</script>
